import { createActions } from 'utils/actions';

export const fetchCommunityUrl = createActions('community', 'FETCH_COMMUNITY_URL', {
    asPromise: true,
});
